import { Link } from 'component/Link'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { getColorTranslation } from 'page/StartScreen/combine/utils'
import { store } from 'store/store'

type Props = {
  color: string
}

export const ColorCheckbox = observer(({ color }: Props) => {
  const item = store.item!
  const selected = item.rec.color.selected(color)

  const onClick = useLatestCallback(() => {
    item.rec.color.toggle(color)
  })

  return <Link action={onClick}>
    <Space minHeight={48} opposite>
      <Typo size={15} upper>
        {getColorTranslation(color)}
      </Typo>
      {selected && <Icon size={20} name="check" />}
    </Space>
  </Link>
})
